<div id="wrapper">
	<div>
		<app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
	</div>
	<div style="margin-bottom: 0px;">
		<app-tab-nav (updatePostpaid)="this.postpago=$event" 
			(updatePrepaid)="this.prepago=$event"
			(updateFixed)="this.telefoniaFijo=$event" 
			(updateTotalAccountList)="this.totalAccountList=$event"
			(updateCurrentList)="this.currentList=$event" 
			(updateSelectBan)="this.selectBan=$event"
			(updateInitializeData)="this.initializeData()">
		</app-tab-nav>
	</div>
	<app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
	<div class="allcont logsize" *ngIf="this.totalAccountList > 0">
		<div class="basicrow ">
			<div class="container">
				<div class="basicr-line-i">
					<div class="fulltitle  f-btitle autodef">
						<span class="icon-dash-01"></span> Factura Electrónica
					</div>
					<div class="pull-right">
						<label class="label-r sidenmbr vcenter w-auto">
							<span class="tabcell">
								N&uacute;mero de Cuenta
							</span>
						</label>
						<div class="autorow subsc  mob-wid pull-right">
							<div>
								<select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f" style="background-image:url(/assets/images/selectabarrw.png)">
									<option *ngFor="let list of this.currentList" [ngValue]="list.account">{{list.account}}</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="basicrow mbott-i">
			<div class="container">
				<app-paperless-module [paperless]="this.paperless"></app-paperless-module>
			</div>
		</div>
	</div>
	<app-footer></app-footer>
</div>